/**
 * We have to separate slideHints from templates
 * because they are different for each screenType
 */

export const slideHints = [
  {
    hint: (
      <>
        Must be an optimised/compressed H.264 MP4 file, 3840 x 1080px.
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "videoUrl",
    screenIds: [1],
    templates: ["Text & Video - 1", "Text & Video - 2"],
  },
  {
    hint: (
      <>
        Must be a JPG or PNG file, landscape format, 3840 x 1080px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "imageUrl",
    screenIds: [1],
    templates: ["Text & Image - 1", "Text & Image - 2"],
  },
  {
    hint: (
      <>
        Must be an optimised/compressed H.264 MP4 file, 1920 x 2160px.
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "videoUrl",
    screenIds: [2, 3, 501, 502, 6, 7, 8],
    templates: ["Text & Video - 1", "Text & Video - 2"],
  },
  {
    hint: (
      <>
        Must be a JPG or PNG file, landscape format, 1920 x 2160px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "imageUrl",
    screenIds: [2, 3, 501, 502, 6, 7, 8],
    templates: ["Text & Image - 1", "Text & Image - 2"],
  },
  {
    hint: (
      <>
        Must be an optimised/compressed H.264 MP4 file, 2160 x 1920px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "videoUrl",
    screenIds: [4],
    templates: ["Text & Video - 1", "Text & Video - 2"],
  },
  {
    hint: (
      <>
        Must be a JPG or PNG file, landscape format, 2160 x 1920px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "imageUrl",
    screenIds: [4],
    templates: ["Text & Image - 1", "Text & Image - 2"],
  },
  {
    hint: (
      <>
        Must be an optimised/compressed H.264 MP4 file, 7680 x 1080px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "videoUrl",
    screenIds: [1],
    templates: ["Fullscreen Video"],
  },
  {
    hint: (
      <>
        Must be a JPG or PNG file, landscape format, 7680 x 1080px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "imageUrl",
    screenIds: [1],
    templates: ["Fullscreen Image"],
  },
  {
    hint: (
      <>
        Must be an optimised/compressed H.264 MP4 file, 3840 x 2160px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "videoUrl",
    screenIds: [2, 3, 501, 502, 6, 7, 8],
    templates: ["Fullscreen Video"],
  },
  {
    hint: (
      <>
        Must be a JPG or PNG file, landscape format, 3840 x 2160px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "imageUrl",
    screenIds: [2, 3, 501, 502, 6, 7, 8],
    templates: ["Fullscreen Image"],
  },
  {
    hint: (
      <>
        Must be an optimised/compressed H.264 MP4 file, 2160 x 3840px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "videoUrl",
    screenIds: [4],
    templates: ["Fullscreen Video"],
  },
  {
    hint: (
      <>
        Must be a JPG or PNG file, portrait format, 2160 x 3840px
        <br />
        Filenames must not contain special characters or spaces - letters,
        numbers and hyphens/underscores only.
        <br />
        <span className="text-warningRed">
          Avoid leaving this page or closing this tab when uploading a file
        </span>
      </>
    ),
    field: "imageUrl",
    screenIds: [4],
    templates: ["Fullscreen Image"],
  },
  {
    hint: "Enter the type of donor as a short subheading. 5-8 words max",
    field: "subheading",
    screenIds: [502],
    templates: ["Donor List"],
  },
  {
    hint: "A brief description of the role of this group of donors. 20-25 words max",
    field: "caption",
    screenIds: [502],
    templates: ["Donor List"],
  },
  {
    hint: "Max 20 words",
    field: "message",
    screenIds: [1, 4],
    templates: ["Text"],
  },
  {
    hint: "Max 30 words",
    field: "message",
    screenIds: [2, 3, 501, 502, 6, 7, 8],
    templates: ["Text"],
  },
  {
    hint: "Optional field. Max 8-10 words",
    field: "title",
    screenIds: [1],
    templates: [
      "Text & Image - 1",
      "Text & Image - 2",
      "Text & Video - 1",
      "Text & Video - 2",
    ],
  },
  {
    hint: "Optional field. Max 6 words recommended",
    field: "title",
    screenIds: [2, 3, 4, 501, 502, 6, 7, 8],
    templates: [
      "Text & Image - 1",
      "Text & Image - 2",
      "Text & Video - 1",
      "Text & Video - 2",
    ],
  },
  {
    hint: "Optional field. Max 6-10 words recommended",
    field: "subheading",
    screenIds: [2, 3, 4, 501, 502, 6, 7, 8],
    templates: [
      "Text & Image - 1",
      "Text & Image - 2",
      "Text & Video - 1",
      "Text & Video - 2",
    ],
  },
  {
    hint: "15-18 words recommended",
    field: "caption",
    screenIds: [1],
    templates: [
      "Text & Image - 1",
      "Text & Image - 2",
      "Text & Video - 1",
      "Text & Video - 2",
    ],
  },
  {
    hint: "30-40 words recommended",
    field: "caption",
    screenIds: [2, 3, 501, 502, 6, 7, 8],
    templates: [
      "Text & Image - 1",
      "Text & Image - 2",
      "Text & Video - 1",
      "Text & Video - 2",
    ],
  },
  {
    hint: "20-25 words recommended",
    field: "caption",
    screenIds: [4],
    templates: [
      "Text & Image - 1",
      "Text & Image - 2",
      "Text & Video - 1",
      "Text & Video - 2",
    ],
  },
];
